<template>
  <transition
    enter-active-class="mobile:transition-transform mobile:duration-[250ms] mobile:ease-in-out"
    leave-active-class="mobile:transition-transform mobile:duration-[250ms] mobile:ease-in-out"
    enter-from-class="mobile:translate-x-full"
    leave-to-class="mobile:translate-x-full"
  >
    <aside
      v-if="isOpen"
      class="pc:w-[450px] pc:static pc:translate-x-0 pc:h-screen mobile:fixed mobile:top-0 mobile:right-0 mobile:z-100 mobile:h-full mobile:w-[450px] mobile:max-w-[100vw] flex h-full shrink-0 flex-col bg-[url('@/assets/bg_pattern.webp')] bg-cover bg-center bg-no-repeat"
    >
      <Preview
        v-if="previewReady"
        ref="previewComponent"
        :page="page || 'HOME'"
        :page-data="pageData"
        :packed-data="computedPackedData"
      />

      <div v-if="!previewReady" class="flex h-full items-center justify-center">
        <UiProgressCircular indeterminate color="primary" />
      </div>
    </aside>
  </transition>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'

import { useAppDataStore, useGrabData } from '@/shared/store/app-data.store'
import { usePreviewStore } from '@/shared/store/preview.store'
import { type PreviewGrabData } from '@/shared/types/applicationData.type'

import UiProgressCircular from '../ui/UiProgressCircular.vue'
import Preview from './Preview.vue'

const previewComponent = ref<{ forceResync: () => void } | null>(null)
const previewReady = ref(false)

const previewStore = usePreviewStore()
const isOpenRef = computed(() => previewStore.isOpen)
const page = computed(() => previewStore.page)
const pageData = computed(() => previewStore.pageData)
const packedData = computed(() => previewStore.packedData)
const getGrabData = useGrabData()

const computedPackedData = computed<PreviewGrabData | undefined>(
  () => packedData.value ?? getGrabData.value ?? undefined,
)

const isOpen = computed({
  get: () => isOpenRef.value,
  set: (value: boolean) => {
    previewStore.setOpen(value)
  },
})

watch(
  computedPackedData,
  (data: PreviewGrabData | null | undefined) => {
    if (data && !previewReady.value) {
      previewReady.value = true
    }
  },
  { immediate: true },
)

onMounted(async () => {
  if (!packedData.value) {
    await useAppDataStore
      .getState()
      .loadCurrentData({ filterOnlyVisible: true })
  }
})
</script>
